@if (patientDetails(); as patientDetails) {
  <div
    class="flex flex-col gap-4 rounded-md border border-solid border-gray-200 p-4"
  >
    <div class="flex items-center justify-between">
      <p class="text-lg font-semibold">Patient Details</p>
      <button
        mat-icon-button
        matTooltip="Copy Details"
        (click)="copyPatientDetailsToClipboard()"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>

    <div
      class="grid-label-value grid w-full auto-rows-auto items-start gap-x-6 gap-y-4"
      [formGroup]="optionalPatientDetailsForm"
    >
      <!-- Name -->
      <span class="font-bold">Name</span>
      @if (patient(); as patient) {
        <div
          class="text-primary-500 flex items-center gap-2 hover:cursor-pointer"
          (click)="openPatientInNewTab.emit(patient.ref.id)"
        >
          <span>{{ patient.name }}</span>
          <mat-icon fontSet="material-symbols-outlined" class="icon-xs">
            open_in_new
          </mat-icon>
        </div>
      } @else {
        <span>{{ patientDetails.name }}</span>
      }

      <!-- Date of Birth -->
      <span class="font-bold">Date of Birth</span>
      <span>
        {{ patientDetails.dateOfBirth | moment | amDateFormat: dateFormat }}
      </span>

      <!-- Primary Contact -->
      @if (displayPrimaryContact(); as primaryContact) {
        <span class="font-bold">Primary Contact</span>
        <span>
          {{ primaryContact.patient.name }}
          <span class="ml-2 rounded-full bg-gray-200 px-2 py-1 text-xs">
            {{ primaryContact.type | splitCamel | titlecase }}
          </span>
        </span>
      }

      <!-- Phone -->
      @if (displayContactNumbers(); as contactNumbers) {
        @if (contactNumbers.length) {
          <div class="flex items-center gap-2">
            <ng-container
              *ngTemplateOutlet="
                toggleButton;
                context: {
                  field: 'includePhone',
                  value: optionalPatientDetailsForm.value.includePhone
                }
              "
            />
            <span class="font-bold">Phone</span>
          </div>

          <div class="flex flex-col gap-2">
            @for (number of contactNumbers; track number) {
              <span>
                <a [href]="'tel:' + number.number">
                  {{ number.number }}
                </a>
                @if (number.label) {
                  <span class="ml-2 rounded-full bg-gray-200 px-2 py-1 text-xs">
                    {{ number.label | titlecase }}
                  </span>
                }
              </span>
            }
          </div>
        }
      }

      <!-- Email -->
      @if (patientDetails.email; as email) {
        <div class="flex items-center gap-2">
          <ng-container
            *ngTemplateOutlet="
              toggleButton;
              context: {
                field: 'includeEmail',
                value: optionalPatientDetailsForm.value.includeEmail
              }
            "
          />
          <span class="font-bold">Email</span>
        </div>
        <span>
          <a [href]="'mailto:' + email">
            {{ email }}
          </a>
        </span>
      }

      <!-- Address -->
      @if (patientDetails.address; as address) {
        <div class="flex items-center gap-2">
          <ng-container
            *ngTemplateOutlet="
              toggleButton;
              context: {
                field: 'includeAddress',
                value: optionalPatientDetailsForm.value.includeAddress
              }
            "
          />
          <span class="font-bold">Address</span>
        </div>
        <span>{{ address }}</span>
      }
    </div>
  </div>
} @else {
  <pr-empty-state
    image="list"
    title="patient selected"
    imageClasses="w-32"
    titleClasses="!text-sm"
    [descriptionEnabled]="false"
  />
}

<ng-template #toggleButton let-field="field" let-value="value">
  @if (editable()) {
    <button
      mat-icon-button
      class="icon-sm"
      type="button"
      [matTooltip]="value ? 'Hide From Contact' : 'Share With Contact'"
      (click)="toggleField(field)"
    >
      <mat-icon>
        {{ value ? 'visibility' : 'visibility_off' }}
      </mat-icon>
    </button>
  }
</ng-template>
